import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

const PRESETS = {
  shareButtonWidth: utils.rem(45),
  shareButtonHeight: utils.rem(45),
};

export const StyledShareButtonWrapper = styled.div(({ theme }) => {
  return css`
    width: ${PRESETS.shareButtonWidth};
    height: ${PRESETS.shareButtonHeight};
    position: relative;
    aspect-ratio: 1;
    border-radius: ${utils.rem(theme.Border.Radius.Medium)};
    background-color: ${theme.Color.Neutrals.Paper};
    display: flex;
    justify-content: center;
    align-items: center;
  `;
});
